import React, { useEffect, useState } from "react"
import { withRouter } from "react-router-dom"
import API from "../../apis"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Card, CardBody, Col, Row, Spinner } from "reactstrap"

const ListMatieres = props => {
  if (localStorage.getItem("userAuthEnseignant")) {
    var userAuthEnseignant = JSON.parse(
      localStorage.getItem("userAuthEnseignant")
    )
    var enseignant_id = userAuthEnseignant.user.enseignant_id
  }
  const [listExamen, setListExamen] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(async () => {
    setLoading(false)
    const resE = await API.post("examen/final/list_matiere_enseignant", {
      enseignant_id: enseignant_id,
      session_id: props.session,
      semestre_id: props.semestre_value,
    }).then(resE => {
      setListExamen(resE.data.ListMatieres)
      setLoading(true)
    })
  }, [props.semestre_value, props.session])

  return (
    <React.Fragment>
      {loading ? (
        <Row className="mt-4">
          {listExamen.length != 0 ? (
            listExamen.map((element, key) => (
              <Col
                onClick={() =>
                  props.history.push({
                    pathname: "/ListSalle",
                    state: {
                      element: element,
                    },
                  })
                }
                xl="3"
                sm="4"
                key={"_col_" + key}
              >
                <Card outline color="primary" className="border border-primary">
                  <CardBody style={{ cursor: "pointer" }}>
                    <div className="mt-2 text-center cursor-pointer">
                      <h5>
                        {element.cycle} - {element.niveau}
                      </h5>
                    </div>
                    <div className="mt-2 text-center cursor-pointer">
                      <h5>{element.specialite}</h5>
                    </div>
                    <div className="mt-4 text-center cursor-pointer">
                      <h5>{element.date}</h5>
                    </div>
                    <div className="mt-4 text-center cursor-pointer">
                      <h5>{element.quart_examen}</h5>
                    </div>
                    <div className="mt-4 text-center">
                      <h5 style={{ color: "#556ee6" }}>{element.matiere}</h5>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))
          ) : (
            <Card>
              <CardBody>
                <h4 className="text-center mt-4">
                  Aucun examen pour le moment 😉
                </h4>
              </CardBody>
            </Card>
          )}
        </Row>
      ) : (
        <div className="mt-4">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {" "}
            <Spinner type="grow" className="ms-6" color="primary" />
          </div>
          <h4 style={{ textAlign: "center", marginTop: "2%" }} className="ms-6">
            {" "}
            {"Chargement"} ...{" "}
          </h4>
        </div>
      )}
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(ListMatieres))
ListMatieres.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  semestre_value: PropTypes.object,
  session: PropTypes.object,
  t: PropTypes.any,
}
